/** Extract human message from Frappe / axios errors. */
export function getApiErrorMessage(err: unknown, fallback = 'Request failed'): string {
  const e = err as {
    message?: string;
    response?: {
      status?: number;
      data?: {
        message?: string | { message?: string };
        exc_type?: string;
        _server_messages?: string;
      };
    };
  };
  const data = e?.response?.data;
  if (data?._server_messages) {
    try {
      const messages = JSON.parse(data._server_messages);
      if (Array.isArray(messages) && messages.length > 0) {
        const first = typeof messages[0] === 'string' ? JSON.parse(messages[0]) : messages[0];
        if (first?.message) return String(first.message).replace(/<[^>]+>/g, '');
      }
    } catch {
      /* fall through */
    }
  }
  if (typeof data?.message === 'string' && data.message) return data.message;
  if (data?.message && typeof data.message === 'object' && data.message.message) {
    return String(data.message.message);
  }
  const status = e?.response?.status;
  if (status === 401 || data?.exc_type === 'AuthenticationError') {
    return 'Cloud session expired. Please Online login again.';
  }
  if (status === 403) {
    return data?.exc_type
      ? `Permission denied (${data.exc_type}). If you are Admin, reconnect (Online login) — cloud session may have expired.`
      : 'Permission denied (403). Reconnect with Online login if your cloud session expired.';
  }
  return e?.message || fallback;
}
